var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9937 18.2501C12.2365 18.5116 12.6249 18.5116 12.8192 18.2501L13.7903 17.2043C14.0331 16.9951 14.0331 16.5767 13.7903 16.3153L9.08023 11.3998L21.171 11.3998C21.4624 11.3998 21.7537 11.1383 21.7537 10.7723V9.30808C21.7537 8.99432 21.4624 8.68057 21.171 8.68057L9.08023 8.68057L13.7903 3.81736C14.0331 3.55589 14.0331 3.13755 13.7903 2.92838L12.8192 1.88253C12.6249 1.62107 12.2365 1.62107 11.9937 1.88253L4.80718 9.62183C4.56439 9.8833 4.56439 10.2493 4.80718 10.5108L11.9937 18.2501ZM2.52498 19.4528L2.52498 0.627511C2.52498 0.313755 2.23364 0 1.9423 0L0.582689 0C0.242787 0 0 0.313755 0 0.627511L0 19.4528C0 19.8189 0.242787 20.0803 0.582689 20.0803H1.9423C2.23364 20.0803 2.52498 19.8189 2.52498 19.4528Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseArrow);
export default __webpack_public_path__ + "static/media/close-arrow.16c9927c261cc44fa0d659c8a59887e9.svg";
export { ForwardRef as ReactComponent };